<template>
  <div class="box">
    <!-- log -->
    <div class="log" @click="gohome"><img src="@/image/home/LOGO@2x.png" alt="" /></div>

    <!-- 导航栏选项 -->
    <div class="itembox">
      <!-- <div class="item">首页</div> -->
      <!-- <router-link to="/" class="item"> 首页</router-link> -->

      <!-- 咨询产品-->
      <div class="showbox" v-for="item in menus" :key="item.id" @mouseover="showbox(item.id)" @mouseleave="show = ''">
        <router-link :to="item.url" class="item"> {{ item.name }}</router-link>
        <div class="shows" v-if="show == item.id" @mouseleave="show = ''">
          <div class="show" v-for="i in item.chlid" :key="i.id">
            <div class="shbox">
              <div class="sh">
                <router-link :to="i.url">{{ i.name }}</router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 右边咨询  -->
    <div class="right">
      <div class="number">{{ tel }}</div>
      <div class="zixun" @click="goBto">免费咨询</div>
    </div>
    <!-- 产品资讯 -->
  </div>
</template>

<script>
export default {
  name: 'DczxxNave',

  data() {
    return {
      show: '',
      tel: '',
      menus: [],
    }
  },

  mounted() {
    this.getwebConfig()
    this.getmenu()
  },

  methods: {
    showbox(index) {
      this.show = index
    },
    //到底
    goBto() {
      document.getElementById('bot').scrollIntoView(true)
    },
    gohome() {
      this.$router.push('/')
    },
    getwebConfig() {
      this.$axios
        .get('/index/Dt/webConfig', {
          headers: {
            Authorization: 'www.ditingzixun.cn',
          },
        })
        .then((res) => {
          this.tel = res.data.data.sll_tel
        })
    },
    getmenu() {
      this.$axios
        .get('/index/Dt/menu', {
          headers: {
            Authorization: 'www.ditingzixun.cn',
          },
        })
        .then((res) => {
          this.menus = res.data.data
        })
    },
  },
}
</script>

<style lang="scss" scoped>
a {
  text-decoration: none;
  // margin: 15px 0;
  // display: block;
  color: #333;
  font-family: sans-serif;
}

// 下拉栏

.showbox {
  height: 32px;
  line-height: 32px;
  // padding-bottom: 20px;
  z-index: 100;
  // border: 1px solid;
  position: relative;
}
.shows {
  // border: 1px solid;
  position: absolute;
  top: 30px;
  left: -20px;
  text-align: center;
  box-shadow: 1px 1px 5px 2px #efefef;
  box-sizing: border-box;

  .shbox {
    z-index: 100;
    // margin-top: 10px;
    background-color: #ffffff;
  }

  .sh {
    z-index: 100;
    // margin: 15px 0;
    font-size: 15px;
    color: #333333;
    padding: 10px 18px;
    line-height: normal;
    box-sizing: border-box;
  }
  .sh a:hover {
    color: #4581fb;
  }
}
// 下拉栏  end----------
.box {
  height: 64px;
  width: 100%;
  // border: 1px solid;
  align-items: center;
  display: flex;
  box-shadow: 0px 3px 3px #efefef;
}

.log {
  width: 140px;
  height: 42px;
  margin-left: 320px;
  img {
    width: 100%;
    height: 100%;
  }
}
.itembox {
  height: 100%;
  margin-left: 30px;
  display: flex;
  align-items: center;

  .item {
    margin-right: 35px;
    position: relative;
    font-size: 15px;
  }
  .item:hover {
    color: #4581fb;
  }
  .item:hover::after {
    content: ' ';
    display: block;
    background-color: #4581fb;
    height: 2px;
    width: 100%;
    position: absolute;
    margin-top: 15px;
  }
}
.right {
  margin-left: 100px;
  display: flex;

  .number {
    margin-top: 0px;
    font-size: 24px;
  }
  .zixun {
    margin-top: 2px;
    margin-left: 5px;
    font-size: 13px;
    color: #fff;
    border-radius: 2px;
    height: 28px;
    width: 80px;
    background-color: #e94d4d;
    line-height: 28px;
    text-align: center;
  }
}
</style>
